module.exports = __webpack_public_path__ + "static/media/lib.0154d984.png";